import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AlertMessageService, LogoutService, MenuFeatureService, User, UserService } from '@serpro/ngx-suite-rfb';
import { AuthService } from './auth/auth.service';
import { appRoute } from './shared/consts/app-routes';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

    title = 'sijut-frontend';

    public loggedinUser: User | undefined;
    public passwordUrl: string;
    public profileUrl: string;

    // Propriedades vindas das rotas
    public carregouPropriedades = false;
    public esconderCabecalhoERodape = false;
    public consultaInterna = false;
    public consultaExterna = false;
    public gerirAto = false;

    constructor(
        private alertMessageService: AlertMessageService,
        private menuFeatureService: MenuFeatureService,
        private authService: AuthService,
        private userService: UserService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private logoutService: LogoutService,
    ) { }

    ngOnInit(): void { 

        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(() => {
        
                // Navega através das rotas aninhadas até encontrar a rota mais "profunda"
                let route = this.activatedRoute.firstChild;
                while (route?.firstChild) {
                    route = route.firstChild;
                }

                if (route?.snapshot.data['esconderCabecalhoERodape'] !== undefined) {
                    this.esconderCabecalhoERodape = route.snapshot.data['esconderCabecalhoERodape'];
                } else {
                    this.esconderCabecalhoERodape = false; // Valor padrão, caso não seja definido na rota
                }

                if (route?.snapshot.data['consultaInterna'] !== undefined) {
                    this.consultaInterna = route.snapshot.data['consultaInterna'];
                } else {
                    this.consultaInterna = false;
                }

                if (route?.snapshot.data['consultaExterna'] !== undefined) {
                    this.consultaExterna = route.snapshot.data['consultaExterna'];
                } else {
                    this.consultaExterna = false;
                }

                if (route?.snapshot.data['gerirAto'] !== undefined) {
                    this.gerirAto = route.snapshot.data['gerirAto'];
                } else {
                    this.gerirAto = false;
                }

                this.carregouPropriedades = true;
            });

        this.menuFeatureService.featureClick$.subscribe(() => {
            this.alertMessageService.dismissAll();
        });

        this.authService.loggedInUser$.subscribe(
            user => {
                this.loggedinUser = user;
                this.userService.setUser(user as User);
            }
        );

        this.logoutService.logout$.subscribe(() => {
            this.logout();
        });
    }

    public logout() {
        this.authService.logout();
    }

    public login() {
        this.router.navigate([`${appRoute.login}`]);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public sessionTimeFeedback(event: any) {
        if (event === 'expired') {
            this.alertMessageService.warn('A sessão encerrou. Será preciso logar novamente.');
        }
        if (event === 'warning') {
            this.alertMessageService.info('Esta sessão irá se encerrar em breve.');
        }
    }
}
